import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addFlat } from '../../actions/propertyActions';

class AddFlatModal extends Component {
  constructor() {
    super();

    this.state = {
      name: ''
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();
    const { property } = this.props.properties;

    const flatData = {
      name: this.state.name,
      property: property._id
    };

    this.props.addFlat(flatData);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.properties.property !== nextProps.properties.property) {
      window.$(`#newFlatModal`).modal('hide');
      this.setState({ name: '' });
    }
  }

  render() {
    return (
      <div
        className="modal fade"
        id="newFlatModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addFlatLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addFlatLabel">
                Add a flat
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-section">
                <h3 className="heading">General Info</h3>

                <div className="row">
                  <div className="col-md-6">
                    <div className="field">
                      <h5 className="heading">Flat Name</h5>
                      <input
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                onClick={this.onSubmit}
                className="btn green-button"
              >
                Add Flat
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  properties: state.properties
});

export default connect(
  mapStateToProps,
  { addFlat }
)(AddFlatModal);
